import {
  FlexibleReport4xxErrorCodes,
  FlexibleReport5xxErrorCodes,
  FlexibleReportError,
  ReportFailureCode
} from '@flexible-reports/store/api/errors';

const FLEXIBLE_REPORT_4XX_ERROR_CODES = Object.values(FlexibleReport4xxErrorCodes);
const FLEXIBLE_REPORT_5XX_ERROR_CODES = Object.values(FlexibleReport5xxErrorCodes);
const FLEXIBLE_REPORT_FAILURE_CODES = Object.values(ReportFailureCode);

/**
 * Maps HTTP status codes to regex patterns that indicate non-fatal errors.
 * Empty array means all errors with that status code are non-fatal.
 */
export const NON_FATAL_STATUS: { [key: number]: RegExp[] } = {
  401: [
    /^Not authorized$/,
    /\bInvalid CSRF token\b/,
    /\bUnauthorized exception while handling 1P Multi-Accounts Request: Caller is not authorized to access one or more accounts from 'accessRequestedAccounts'\b/
  ],
  404: [],
  413: [],
  400: []
};

export const NON_FATAL_MESSAGES = [/Network Error/i, /Chunk Loading Error/i, /Loading chunk.*failed/i, /Request aborted/i];

export const NON_FATAL_EXCEPTIONS = [DOMException];

const ERROR_CODES = new Set<string>([
  ...FLEXIBLE_REPORT_4XX_ERROR_CODES,
  ...FLEXIBLE_REPORT_5XX_ERROR_CODES,
  ...FLEXIBLE_REPORT_FAILURE_CODES
]);
export const parseFlexibleReport4xxErrorCode = (message: string): FlexibleReport4xxErrorCodes => {
  return FLEXIBLE_REPORT_4XX_ERROR_CODES.includes(message as any)
    ? (message as FlexibleReport4xxErrorCodes)
    : FlexibleReport4xxErrorCodes.UNKNOWN;
};

export const parseFlexibleReportErrorCode = (message: string | null): FlexibleReportError => {
  return !message ? null : ERROR_CODES.has(message) ? (message as FlexibleReportError) : FlexibleReport4xxErrorCodes.UNKNOWN;
};

export function matchesFatalPatterns(code?: number, data?: any) {
  if (NON_FATAL_EXCEPTIONS.some(exception => data instanceof exception)) {
    return false;
  }

  const message: string = typeof data === 'string' ? data : data?.message || data?.error?.message;

  if (message && NON_FATAL_MESSAGES.some(pattern => pattern.test(message))) {
    return false;
  }

  const nonFatalPatterns = NON_FATAL_STATUS[code ?? -1];
  if (!nonFatalPatterns) {
    return true;
  }

  if (nonFatalPatterns.length === 0) {
    // Assumes that if there are no fatal patterns for the error code, then that error code is safe to not page
    return false;
  }

  if (!message) {
    // If we have known non-fatal pattern but there's no message was provided, then page so that we can debug and escalate
    return true;
  }

  return !nonFatalPatterns.some(pattern => pattern.test(message));
}

export function rtkErrorMatchesFatalPatterns(error?: any) {
  const status = error && typeof error === 'object' && 'status' in error ? (error.status as number) : -1;
  const data = error && typeof error === 'object' && 'data' in error ? error.data : null;
  return matchesFatalPatterns(status, data);
}
